// https://vuex.vuejs.org/en/state.html

export default {
  alert: {
    alertType: null,
    body: null
  },
  progress:false,
  userDetail: null
}
